// One MediaQueryList for the whole bundle. Every motion module reads the same object,
// so a preference flipped mid-session is seen identically everywhere — and each module
// registers its own change handler rather than this file trying to keep a list of them.
//
// CSS covers what CSS owns: the blanket rule in _reset.scss collapses every transition
// and keyframe animation. This is for the motion CSS cannot reach — Lenis interpolating
// the scroll position, Rellax writing transforms per frame, timers advancing the hero,
// and media that plays on its own.
const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

const prefersReducedMotion = () => reducedMotionQuery.matches;

const onReducedMotionChange = (handler) => reducedMotionQuery.addEventListener("change", handler);

export { onReducedMotionChange, prefersReducedMotion };
